var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _g2, _path14, _g3, _path15, _g4, _path16, _g5, _path17, _g6, _path18, _g7, _path19, _g8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatplazaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 464,
    height: 93,
    viewBox: "0 0 464 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_435)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.733 29.564H25.267C23.872 29.564 23 28.169 23 27.064V24.189C23 23.084 23.872 22.564 25.267 22.564H94.733C96.128 22.564 97 23.084 97 24.189V27.064C97 28.169 96.128 29.564 94.733 29.564Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.733 43.564H25.267C23.872 43.564 23 42.169 23 41.064V38.189C23 37.084 23.872 36.564 25.267 36.564H64.733C66.128 36.564 67 37.084 67 38.189V41.064C67 42.169 66.128 43.564 64.733 43.564Z",
    fill: "#CCCCCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.445 35.3918C177.52 33.3401 174.198 31.5231 170.558 31.5231C161.384 31.5231 154.897 38.0782 154.897 47.3956C154.897 56.7913 160.988 63.5833 170.558 63.5833C174.195 63.5833 177.914 61.6076 180.761 59.5537L179.1 73.9244C176.884 75.1089 172.062 75.8979 169.609 75.8979C153.079 75.8979 141.452 64.5287 141.452 47.7086C141.452 31.521 153.079 19.202 169.53 19.202C172.534 19.202 175.698 19.678 178.388 20.9408L180.445 35.3918Z",
    fill: "#4D4D4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.598 36.4981C199.971 34.0509 204.005 32.6294 207.405 32.6294C218.555 32.6294 222.274 39.7365 222.274 49.8429V74.0049L209.937 75.2698V50.7101C209.937 45.9721 207.485 43.6835 203.767 43.6835C200.049 43.6835 197.598 45.9742 197.598 50.7101V74.0049L185.261 75.2698V19.5998L197.598 18.337V36.4981Z",
    fill: "#4D4D4D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.917 34.4464C235.08 33.3401 239.669 32.6294 243.07 32.6294C253.193 32.6294 260.152 36.8154 260.152 46.8414V74.0048L249.398 75.2697V71.2402H249.239C246.866 74.8742 243.307 75.9 239.116 75.9C229.943 75.9 224.96 69.8992 224.96 61.212C224.96 53.0009 231.682 47.8672 239.513 47.8672C242.597 47.8672 246.078 49.0518 248.688 50.947C248.767 50.5514 248.767 50.158 248.767 49.6842C248.767 44.0768 246.157 42.8923 240.858 42.8923C237.22 42.8923 233.502 43.8421 230.18 45.3417L231.917 34.4464ZM242.593 66.4261C245.915 66.4261 248.684 64.4526 248.684 61.0556C248.684 57.7411 245.917 55.7633 242.593 55.7633C239.193 55.7633 236.424 57.7389 236.424 61.0556C236.424 64.4526 239.193 66.4261 242.593 66.4261Z",
    fill: "#4D4D4D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.36 44.7115L264.968 34.4464H268.843V26.3917L281.182 21.6537V34.4464H288.22V44.7115H281.182V58.9257C281.182 62.953 284.267 64.0571 287.747 64.0571C288.856 64.0571 290.436 63.8202 290.989 63.5833L287.43 75.7436C286.877 75.8218 286.165 75.9001 285.531 75.9001C274.616 75.9001 268.843 70.6904 268.843 59.8711V44.7093H262.36V44.7115Z",
    fill: "#4D4D4D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.148 20.4691H310.521C323.968 20.4691 332.588 24.4965 332.588 37.8391C332.588 48.4997 323.571 55.0548 312.34 55.0548H307.595V74.0048L294.148 75.2697V20.4691ZM307.593 43.6052H311.468C316.448 43.6052 319.137 41.4752 319.137 37.763C319.137 34.053 316.448 31.9209 311.468 31.9209H307.593V43.6052Z",
    fill: "#4D4D4D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.344 18.337V74.0049L337.005 75.2698V19.5998L349.344 18.337Z",
    fill: "#4D4D4D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.412 34.4464C363.575 33.3401 368.164 32.6294 371.564 32.6294C381.687 32.6294 388.647 36.8154 388.647 46.8414V74.0048L377.893 75.2697V71.2402H377.734C375.361 74.8742 371.802 75.9 367.611 75.9C358.437 75.9 353.454 69.8992 353.454 61.212C353.454 53.0009 360.177 47.8672 368.007 47.8672C371.092 47.8672 374.573 49.0518 377.183 50.947C377.261 50.5514 377.261 50.158 377.261 49.6842C377.261 44.0768 374.651 42.8923 369.353 42.8923C365.715 42.8923 361.997 43.8421 358.675 45.3417L360.412 34.4464ZM371.088 66.4261C374.41 66.4261 377.179 64.4526 377.179 61.0556C377.179 57.7411 374.412 55.7633 371.088 55.7633C367.687 55.7633 364.918 57.7389 364.918 61.0556C364.918 64.4526 367.689 66.4261 371.088 66.4261Z",
    fill: "#4D4D4D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M428.265 63.5833L425.259 74.6373H390.221L408.808 44.1594H393.384L395.835 33.8922H427.71L409.757 63.5833H428.265Z",
    fill: "#4D4D4D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.613 34.4464C438.776 33.3401 443.365 32.6294 446.765 32.6294C456.888 32.6294 463.848 36.8154 463.848 46.8414V74.0048L453.093 75.2697V71.2402H452.935C450.562 74.8742 447.002 75.9 442.812 75.9C433.638 75.9 428.655 69.8992 428.655 61.212C428.655 53.0009 435.377 47.8672 443.208 47.8672C446.293 47.8672 449.774 49.0518 452.384 50.947C452.462 50.5514 452.462 50.158 452.462 49.6842C452.462 44.0768 449.852 42.8923 444.553 42.8923C440.916 42.8923 437.197 43.8421 433.875 45.3417L435.613 34.4464ZM446.288 66.4261C449.61 66.4261 452.379 64.4526 452.379 61.0556C452.379 57.7411 449.613 55.7633 446.288 55.7633C442.888 55.7633 440.121 57.7389 440.121 61.0556C440.121 64.4526 442.89 66.4261 446.288 66.4261Z",
    fill: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5_435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 0,
    width: 90,
    height: 93
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47 0.074C50.5 1.189 52.812 3.376 54.687 6.814C56.981 11.018 57.054 15.564 57.054 15.564H98.13C102.476 15.564 106 18.587 106 22.933V42.193C106 46.54 102.476 50.563 98.13 50.563H50.307C43.919 50.563 38.523 59.855 36.671 70L30.271 92.348C35.646 92.348 44.302 92.753 48.762 82.253C53.838 70.302 53.669 63.565 64.548 63.565H104.113C108.821 63.565 113.013 61.219 116.045 57.287C118.639 53.92 120 49.424 120 44.955V17.086C120 7.505 112.768 0 103.471 0C103.19 0 47 0.074 47 0.074Z",
    fill: "#177FBF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5_435)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.138 -44.146L-15.363 54.644L83.133 136.898L165.634 38.109L67.138 -44.146Z",
    fill: "url(#paint0_linear_5_435)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5_435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 64
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.205 0C13.764 0 9.253 1.493 5.83 4.474C2.071 7.747 0 11.886 0 16.522V44.954C0 49.447 2.025 54.24 5.555 57.788C9.093 61.345 13.705 63.564 18.205 63.564H34.166C34.166 63.564 36.833 56.397 40 53.397C40.877 52.567 42.341 51.564 44 50.563H21.871C17.524 50.563 14 46.54 14 42.193V22.933C14 18.587 17.524 15.564 21.871 15.564H53.899C53.437 10.564 51.478 7.169 49.829 5.221C46.451 1.23 42.687 0 39.772 0H18.205Z",
    fill: "#FF9800"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5_435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.899 0H0V63.564H53.899V0Z",
    fill: "url(#paint1_linear_5_435)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_5_435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 64
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.205 0C13.764 0 9.253 1.493 5.83 4.474C2.071 7.747 0 11.886 0 16.522V44.954C0 49.447 2.025 54.24 5.555 57.788C9.093 61.345 13.705 63.564 18.205 63.564H34.166C34.166 63.564 36.833 56.397 40 53.397C40.877 52.567 42.341 51.564 44 50.563H21.871C17.524 50.563 14 46.54 14 42.193V22.933C14 18.587 17.524 15.564 21.871 15.564H53.899C53.437 10.564 51.478 7.169 49.829 5.221C46.451 1.23 42.687 0 39.772 0H18.205Z",
    fill: "#FF9800"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_5_435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.899 0H0V63.564H53.899V0Z",
    fill: "url(#paint2_linear_5_435)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_5_435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 64
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.205 0C13.764 0 9.253 1.493 5.83 4.474C2.071 7.747 0 11.886 0 16.522V44.954C0 49.447 2.025 54.24 5.555 57.788C9.093 61.345 13.705 63.564 18.205 63.564H34.166C34.166 63.564 36.833 56.397 40 53.397C40.877 52.567 42.341 51.564 44 50.563H21.871C17.524 50.563 14 46.54 14 42.193V22.933C14 18.587 17.524 15.564 21.871 15.564H53.899C53.437 10.564 51.478 7.169 49.829 5.221C46.451 1.23 42.687 0 39.772 0H18.205Z",
    fill: "#FF9800"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_5_435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.899 0H0V63.564H53.899V0Z",
    fill: "url(#paint3_linear_5_435)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_5_435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 0,
    width: 90,
    height: 93
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47 0.074C50.5 1.189 52.812 3.376 54.687 6.814C56.981 11.018 57.054 15.564 57.054 15.564H98.13C102.476 15.564 106 18.587 106 22.933V42.193C106 46.54 102.476 50.563 98.13 50.563H50.307C43.919 50.563 38.523 59.855 36.671 70L30.271 92.348C35.646 92.348 44.302 92.753 48.762 82.253C53.838 70.302 53.669 63.565 64.548 63.565H104.113C108.821 63.565 113.013 61.219 116.045 57.287C118.639 53.92 120 49.424 120 44.955V17.086C120 7.505 112.768 0 103.471 0C103.19 0 47 0.074 47 0.074Z",
    fill: "#177FBF"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_5_435)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.138 -44.146L-15.363 54.644L83.133 136.898L165.634 38.109L67.138 -44.146Z",
    fill: "url(#paint4_linear_5_435)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_5_435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 0,
    width: 90,
    height: 93
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47 0.074C50.5 1.189 52.812 3.376 54.687 6.814C56.981 11.018 57.054 15.564 57.054 15.564H98.13C102.476 15.564 106 18.587 106 22.933V42.193C106 46.54 102.476 50.563 98.13 50.563H50.307C43.919 50.563 38.523 59.855 36.671 70L30.271 92.348C35.646 92.348 44.302 92.753 48.762 82.253C53.838 70.302 53.669 63.565 64.548 63.565H104.113C108.821 63.565 113.013 61.219 116.045 57.287C118.639 53.92 120 49.424 120 44.955V17.086C120 7.505 112.768 0 103.471 0C103.19 0 47 0.074 47 0.074Z",
    fill: "#177FBF"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_5_435)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.138 -44.146L-15.363 54.644L83.133 136.898L165.634 38.109L67.138 -44.146Z",
    fill: "url(#paint5_linear_5_435)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_5_435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 0,
    width: 90,
    height: 93
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M47 0.074C50.5 1.189 52.812 3.376 54.687 6.814C56.981 11.018 57.054 15.564 57.054 15.564H98.13C102.476 15.564 106 18.587 106 22.933V42.193C106 46.54 102.476 50.563 98.13 50.563H50.307C43.919 50.563 38.523 59.855 36.671 70L30.271 92.348C35.646 92.348 44.302 92.753 48.762 82.253C53.838 70.302 53.669 63.565 64.548 63.565H104.113C108.821 63.565 113.013 61.219 116.045 57.287C118.639 53.92 120 49.424 120 44.955V17.086C120 7.505 112.768 0 103.471 0C103.19 0 47 0.074 47 0.074Z",
    fill: "#177FBF"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_5_435)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.138 -44.146L-15.363 54.644L83.133 136.898L165.634 38.109L67.138 -44.146Z",
    fill: "url(#paint6_linear_5_435)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_5_435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 0,
    width: 90,
    height: 93
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M47 0.074C50.5 1.189 52.812 3.376 54.687 6.814C56.981 11.018 57.054 15.564 57.054 15.564H98.13C102.476 15.564 106 18.587 106 22.933V42.193C106 46.54 102.476 50.563 98.13 50.563H50.307C43.919 50.563 38.523 59.855 36.671 70L30.271 92.348C35.646 92.348 44.302 92.753 48.762 82.253C53.838 70.302 53.669 63.565 64.548 63.565H104.113C108.821 63.565 113.013 61.219 116.045 57.287C118.639 53.92 120 49.424 120 44.955V17.086C120 7.505 112.768 0 103.471 0C103.19 0 47 0.074 47 0.074Z",
    fill: "#177FBF"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_5_435)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.138 -44.146L-15.363 54.644L83.133 136.898L165.634 38.109L67.138 -44.146Z",
    fill: "url(#paint7_linear_5_435)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_435",
    x1: 120,
    y1: -1.00001,
    x2: 56.5,
    y2: 77.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBCF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D619A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_435",
    x1: -0.00000121202,
    y1: 32,
    x2: 64,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F08C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E34435"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_435",
    x1: -0.00000121202,
    y1: 32,
    x2: 64,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F08C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E34435"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_435",
    x1: -0.00000121202,
    y1: 32,
    x2: 64,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F08C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E34435"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5_435",
    x1: 120,
    y1: -1.00001,
    x2: 56.5,
    y2: 77.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBCF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D619A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5_435",
    x1: 120,
    y1: -1.00001,
    x2: 56.5,
    y2: 77.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBCF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D619A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5_435",
    x1: 120,
    y1: -1.00001,
    x2: 56.5,
    y2: 77.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBCF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D619A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5_435",
    x1: 120,
    y1: -1.00001,
    x2: 56.5,
    y2: 77.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBCF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D619A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 464,
    height: 93,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatplazaLogo);
export default __webpack_public_path__ + "static/media/chatplaza-logo.9c2951681cab83ac683384dc0e34d496.svg";
export { ForwardRef as ReactComponent };